<template>
  <ACarousel
    v-slot="{ item }"
    :free-mode="{ enabled: $device.isMobile }"
    :show-navigation="!$device.isMobile"
    :breakpoints="breakpoints"
    :items="items"
  >
    <component
      :is="item.to ? ULink : 'div'"
      class="rounded-xl overflow-hidden block relative group"
      :class="[sizeClass]"
      :to="item.to ? $localePath(item.to) : undefined"
    >
      <AImg
        :alt="item.image?.alt || item.name"
        width="300"
        height="300"
        :src="item.image?.url"
        class="sm:group-hover:scale-[1.05] sm:group-hover:rotate-[1.5deg] sm:group-hover:saturate-[1.5] object-cover sm:duration-200 w-full h-full"
      />
      <div
        v-if="item.name || item.description"
        class="absolute bottom-0 left-0 right-0 h-full p-4 text-left from-slate-900 bg-gradient-to-t via-[50%] via-transparent bg-opacity-60 text-white justify-end items-start flex flex-col"
      >
        <p v-bind="titleAttrs" :class="titleClass">{{ item.name }}</p>
        <p v-if="item.description" class="text-sm mt-2">
          {{ item.description }}
        </p>
      </div>
    </component>
  </ACarousel>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'
import { ULink } from '#components'
import { twMerge } from 'tailwind-merge'

type Item = {
  description?: string
  image?: {
    alt?: string
    url: string
  }
  name?: string
  to?: RouteLocationRaw | string
}

type Props = {
  breakpoints?: Record<number, { slidesPerView: 'auto' | number }>
  imagesWidth?: number
  items: Item[]
  size?: 'lg' | 'md' | 'sm' | 'xl'
  titleAttrs?: Record<string, string>
}

const props = withDefaults(defineProps<Props>(), {
  breakpoints: () => ({
    1155: { slidesPerView: 3.5 },
    1350: { slidesPerView: 4.2 },
    320: { slidesPerView: 'auto' },
    767: { slidesPerView: 2.4 },
    930: { slidesPerView: 2.8 },
  }),
  imagesWidth: 640,
  size: 'xl',
})

const sizeClass = computed(() => {
  const sizes = {
    lg: 'size-56',
    md: 'size-48',
    sm: 'size-40',
    xl: 'size-72',
  }
  return sizes[props.size] || sizes.md
})

const titleClass = computed(() =>
  twMerge('font-bold text-lg', props.titleAttrs?.class),
)
</script>

<style scoped></style>
